export const SET_TOKEN = 'SET_TOKEN' // 设置token
export const SET_OPEN_ID = 'SET_OPEN_ID' // 设置openId
export const SET_BIND = 'SET_BIND' // 是否绑定微信帐号
export const SET_USER_INFO = 'SET_USER_INFO' // 设置用户信息
export const SET_LOGOUT = 'SET_LOGOUT' // 设置登出
